import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyVisitsActions } from '../../redux/actions/meActions';
import { clearVisitsActions } from '../../redux/actions/visitsActions';

const useFetchMyVisits = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.visits?.search);
  const visits = useSelector((state) => state.visits?.visits);
  const loading = useSelector((state) => state.visits?.loading);

  const fetchVisits = useCallback(async () => {
    await dispatch(getMyVisitsActions(search));
  }, [search, dispatch]);

  useEffect(() => {
    fetchVisits();
  }, [fetchVisits]);

  useEffect(() => {
    return () => {
      dispatch(clearVisitsActions());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchVisits();
  };

  return { loading, visits, refresh };
};

export default useFetchMyVisits;
